import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
// import TagManager from 'react-gtm-module';

// const tagManagerArgs = {
//   gtmId: 'UA-23241781-1'
// }
// TagManager.initialize(tagManagerArgs);



ReactDOM.render(<App />, document.getElementById('root'));
if (process.NODE_ENV === 'development') {
  registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.js